import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferralWhatsapp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 25,
			cy: 25,
			r: 24.5,
			fill: "white",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 35L15.892 29.3244C14.932 27.7097 14.3793 25.8252 14.3793 23.8103C14.3793 17.84 19.2193 13 25.1897 13C31.16 13 36 17.84 36 23.8103C36 29.7807 31.16 34.6207 25.1897 34.6207C23.3731 34.6207 21.6624 34.1704 20.16 33.3792L14 35Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.0866 27.4084C31.5875 26.465 29.7467 25.3863 29.7467 25.3863C29.3302 25.1488 28.8276 25.1223 28.5902 25.5456C28.5902 25.5456 27.992 26.2629 27.8399 26.366C27.145 26.8368 26.5013 26.8186 25.8515 26.1688L24.3415 24.6588L22.8315 23.1487C22.1817 22.499 22.1635 21.8553 22.6342 21.1604C22.7374 21.0083 23.4547 20.4101 23.4547 20.4101C23.878 20.1723 23.8514 19.6701 23.614 19.2536C23.614 19.2536 22.5352 17.4128 21.5919 16.9136C21.1906 16.7012 20.6978 16.7756 20.3769 17.0964L19.7101 17.7633C17.5947 19.8787 18.6363 22.2668 20.7517 24.3822L22.685 26.3156L24.6184 28.2489C26.7338 30.3643 29.1219 31.4059 31.2374 29.2905L31.9042 28.6237C32.2251 28.302 32.299 27.8093 32.0866 27.4084Z",
			fill: "white"
		})
	]
});
export default SvgReferralWhatsapp;
